import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const DotsHorizontalIcon = ({ className, size }) => {
  if (size === 'small') {
    return (
      <svg
        className={getClassName(className)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
      </svg>
    );
  }

  return (
    <svg
      className={getClassName(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </svg>
  );
};
DotsHorizontalIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

DotsHorizontalIcon.defaultProps = {
  size: 'small',
  className: 'w-5 h-5',
};

export default DotsHorizontalIcon;
